import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, finalize, Subject } from 'rxjs';
import { AllMessengersService } from '../../../../page-start/all-messengers.service';
import { AuthService } from '../../../../../modules/auth/services/auth.service';
import { InterfaceService } from '../../../../../services/interface.service';
import { ModalService } from '../../../../../services/modal.service';
import { AllService } from '../../../../../services/all.service';
import { SenderService } from '../../../../../services/sender.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TelegramService } from '../../../telegram.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-sender-register',
  templateUrl: './sender-register.component.html',
  styleUrls: ['./sender-register.component.scss']
})
export class SenderRegisterComponent implements OnInit {
  codeSent$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  @Input() telegramService: TelegramService;
  Form: UntypedFormGroup;
  isLoading$: Subject<boolean> = new Subject();
  lastError: any;
  constructor(
    public allMessengersService: AllMessengersService,
    public authService: AuthService,
    public interfaceService: InterfaceService,
    public modalService: ModalService,
    public allService: AllService,
    public senderService: SenderService,
    public cd: ChangeDetectorRef,
    public bsModalRef: BsModalRef
  ) {
  }

  ngOnInit(): void {
    this.Form = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      password: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', Validators.required),
      username: new UntypedFormControl('', Validators.required),
      code: new UntypedFormControl('', []),
    });
  }

  onSubmit() {
    delete this.lastError;
    this.isLoading$.next(true);
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    if (values.code) {
      this.senderService.senderRegisterCheckCode(values)
        .pipe(finalize(() => {
          this.isLoading$.next(false);
          this.cd.detectChanges();
        })).subscribe(
        (result: any) => {
          this.telegramService.setToken(result.token);
          this.telegramService.setAuth();
          this.telegramService.loadProfile();
          this.senderService.setAccount(result.account, this.telegramService);
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    }else{
      this.senderService.senderRegisterSendCode(values.email)
        .pipe(finalize(() => {
          this.isLoading$.next(false);
          this.cd.detectChanges();
        })).subscribe(
        (result: any) => {
          this.codeSent$.next(true);
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    }
  }

  goToAuth() {
    this.authService.mode$.next('Авторизация');
    this.codeSent$.next(false);
    this.Form.get('code').reset();
  }
}
